<div class="page-wrapper">
  <div class="container">
    <h2>COSBOTS Change of Details Form</h2>
    <div class="logout-container">
      <button (click)="logout()" class="logout-btn">Logout</button>
    </div>

    <form [formGroup]="cosbotsForm" (ngSubmit)="onSubmit()">
      <fieldset>
        <legend>Membership</legend>
        <label
          >Membership No: <input type="text" formControlName="membershipNo"
        /></label>

        <label>
          Membership Type:
          <select formControlName="membershipType">
            <option value="">-- Select Type --</option>
            <option value="Group Member">Group Member</option>
            <option value="Individual Member">Individual Member</option>
            <option value="Beneficiary">Beneficiary</option>
          </select>
        </label>
      </fieldset>

      <fieldset>
        <legend>Mobile Payment Type:</legend>
        <label>
          Mobile Payment Type:
          <select formControlName="mobilePaymentType">
            <option value="">-- Select Type --</option>
            <option value="posoMoney">PosoMoney Mobile</option>
            <option value="orangeMoney">Orange Money Mobile</option>
            <option value="fiveMega">5Mega Mobile</option>
            <option value="myzaka">MyZaka Mobile</option>
            <option value="eWallet">E-Wallet</option>
          </select>
        </label>
      </fieldset>

      <fieldset>
        <legend>Identity Details</legend>

        <label>
          Title:
          <select formControlName="title">
            <option value="">-- Select Title --</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Miss">Miss</option>
            <option value="Ms">Ms</option>
            <option value="Dr">Dr</option>
            <option value="Prof">Prof</option>
          </select>
        </label>

        <label>Surname: <input type="text" formControlName="surname" /></label>
        <label
          >First Name: <input type="text" formControlName="firstName"
        /></label>
        <label
          >Pseudonym/Stage Name: <input type="text" formControlName="pseudonym"
        /></label>
        <label
          >Nationality: <input type="text" formControlName="nationality"
        /></label>
        <label
          >Date of Birth: <input type="date" formControlName="dob"
        /></label>
        <label
          >Omang/Passport #: <input type="text" formControlName="passport"
        /></label>
        <label
          >Group Name: <input type="text" formControlName="groupName"
        /></label>
      </fieldset>

      <fieldset>
        <legend>Address and Contact Details</legend>
        <label
          >Postal Address: <input type="text" formControlName="postalAddress"
        /></label>
        <label
          >Physical Address:
          <input type="text" formControlName="physicalAddress"
        /></label>
        <label>
          Locality:
          <select formControlName="locality">
            <option value="">-- Select Type --</option>
            <option value="Village">Village</option>
            <option value="Town">Town</option>
            <option value="City">City</option>
          </select>
        </label>
        <label>Country: <input type="text" formControlName="country" /></label>
        <label
          >Telephone: <input type="text" formControlName="telephone"
        /></label>
        <label>Mobile: <input type="text" formControlName="mobile" /></label>
        <label
          >Email Address: <input type="email" formControlName="email"
        /></label>
        <label
          >Employer: <input type="text" formControlName="employer"
        /></label>
        <label
          >Occupation: <input type="text" formControlName="occupation"
        /></label>
      </fieldset>

      <fieldset>
        <legend>Banking Details</legend>
        <label
          >Bank Name: <input type="text" formControlName="bankName"
        /></label>
        <label>Branch: <input type="text" formControlName="branch" /></label>
        <label
          >Account Number: <input type="text" formControlName="accountNumber"
        /></label>
        <label
          >Account Type: <input type="text" formControlName="accountType"
        /></label>
        <label
          >Payment Reference:
          <input type="text" formControlName="paymentReference"
        /></label>
      </fieldset>

      <button type="submit" [disabled]="!cosbotsForm.valid">Submit</button>
    </form>
  </div>
</div>
